import React, { useEffect, useRef, useState } from "react";
import cn from "classnames";
import styles from "./File.module.sass";
import Icon from "../Icon";
import { UseApi } from "../../hooks/use-api";
import { UploadImage } from "../../Services/lib/admin";
import { UseDisclosure } from "../../hooks/use-disclosure";
import Modal from "../Modal";
import CropperComponent from "./cropper";
import { useUser } from "../../context";
import common from "../../i11/Common";

const ImageInput = ({
	className,
	label,
	tooltip,
	isDisabled,
	title,
	callBack = () => {},
	initial = "",
	isUpload = true,
	setL,
	where,
	aspect_ratio,
	isLoadingForm,
	imageUrl_,
	setImageUrl_ = () => {},
}) => {
	const { locale } = useUser();
	const [image, setImage] = useState([]);
	const [imageUrl, setImageUrl] = useState("");
	const initialImg = useRef(initial);
	const ref = useRef(null);
	const [cropFile, setCropFile] = useState();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const [{ isLoading }, upload] = UseApi({
		service: UploadImage,
		config: {
			headers: {
				"Content-Type": "Multipart/form-data",
			},
			params: {
				miniSize: "NO",
				whereFolder: where,
			},
		},
	});

	useEffect(() => {
		if (!isLoading && imageUrl !== "") {
			setImageUrl("");
			setImageUrl_("");
		}
	}, [isLoadingForm]);

	const onChange = (e) => {
		if (aspect_ratio) {
			if (e.target.files[0].type === "image/gif") {
				setImage(e.target.files);
			} else {
				let url = URL.createObjectURL(e.target.files[0]);
				setCropFile(url);
				onOpen();
			}
		} else {
			setImage(e.target.files);
		}
	};

	const setImages = async (image_) => {
		if (isUpload) {
			const formData = new FormData();
			formData.append("image", image_);
			const res = await upload(formData);
			console.log(res);
			if (res) {
				console.log(res);
				callBack(res);
			}
		} else {
			callBack(image_);
		}
		setImageUrl_(URL.createObjectURL(image_));
		setImageUrl(URL.createObjectURL(image_));
	};

	useEffect(() => {
		if (!image.length || image.length > 1) {
			setImageUrl_(initialImg.current);
			setImageUrl(initialImg.current);
			callBack(initialImg.current);
			return;
		}
		setImages(image[0]);
	}, [image]);

	useEffect(() => {
		if (setL) {
			setL(isLoading);
		}
	}, [isLoading]);

	const onClose_ = () => {
		onClose();
		setCropFile();
	};

	return (
		<>
			<div className={cn(styles.file, className)}>
				{label && (
					<div className={styles.label}>
						{label}{" "}
						{/* {tooltip && (
							<Tooltip
								className={styles.tooltip}
								title={tooltip}
								icon="info"
								place="right"
							/>
						)} */}
					</div>
				)}
				<div
					className={styles.wrap}
					style={{
						backgroundImage: `url(${
							imageUrl !== ""
								? imageUrl_ !== undefined
									? imageUrl_
									: imageUrl
								: initialImg.current
						})`,
						backgroundSize: "contain",
						backgroundPosition: "center",
						backgroundRepeat: "no-repeat",
					}}
				>
					<input
						ref={ref}
						disabled={isLoading || isDisabled}
						required={initialImg.current === ""}
						accept="image/png, image/jpeg, image/gif"
						className={styles.input}
						type="file"
						onChange={onChange}
					/>
					{isDisabled ? null : (
						<div
							className={cn(styles.btn, { disabled: isLoading })}
						>
							<Icon name="upload" size="24" />
							<p>
								{isLoading
									? common[locale].upload
									: title || common[locale].file_or_drag}
							</p>
						</div>
					)}
				</div>
			</div>
			<Modal
				outerClassName={styles.cropOuter}
				visible={isOpen}
				onClose={onClose_}
			>
				{cropFile && (
					<CropperComponent
						aspect_ratio={aspect_ratio}
						setImage={setImage}
						onClose={onClose_}
						image={cropFile}
					/>
				)}
			</Modal>
		</>
	);
};

export default ImageInput;
